<template>
  <div>
    <personel-view-search-panel @search="search" :accessTo="2" />

    <box class="mt-2" :title="$t('missionList')">
      <div class="vacationList">
        <div v-if="list.length > 0">
          <person-mission-list-web
            @onClickMission="onClickMission"
            :list="list"
            class="hidden-sm-and-down"
          />
          <person-mission-list-mob
            @onClickMission="onClickMission"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <!-- <div v-else>
          <EmptyList />
        </div> -->
      </div>
    </box>
  </div>
</template>

<script>
import PersonMissionListMob from '../../components/functionality/periodDetails/PersonMissionList/PersonMissionListMob.vue';
import PersonMissionListWeb from '../../components/functionality/periodDetails/PersonMissionList/PersonMissionListWeb.vue';
import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanelWhitParam.vue";
// import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanel.vue";

export default {
  components: {
    PersonelViewSearchPanel,
    PersonMissionListWeb,
    PersonMissionListMob,
  },
  data() {
    return {
      list: [],
      type:0,
    };
  },
  methods: {
    search(searchParams) {
      debugger;
      const params = new URLSearchParams();
      params.append("beginDate", searchParams.beginDate);
      params.append("endDate", searchParams.endDate);
      params.append("searchKind", searchParams.searchKind);
      params.append("perno", searchParams.perno);

      this.$store.dispatch("PersonMissionList", { params }).then((result) => {
        //console.log(result);
        if (result.type === "success") {
          this.list = result.data;
          debugger
        } else {
          this.list = [];
        }
      });
    },
    onClickMission(){},
  },
};
</script>

<style>
</style>